import posthog from 'posthog-js';
import { getSABAppInstance_Normal } from './shopify-app-bridge/app';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import { store } from 'src/stores/store';
import apiService from 'src/services/api-service';

const initPosthog = async tenantApp => {
  const app = getSABAppInstance_Normal();

  const token = await getSessionToken(app);

  const response = await decodeToken(token);
  const email = tenantApp?.externalInfo?.email || tenantApp?.optEmail || '';
  const externalId = tenantApp?.externalInfo?.id || '';
  const distinctId = response?.sub || email || 'anonymous_user';
  const userId = 'boostcommerce_' + distinctId;
  const groupId = 'boostcommerce_' + externalId;
  apiService.setUserId(distinctId);

  const userProperties = {
    email,
    group_id: groupId,
    app: 'boostcommerce',
    platform: 'shopify-client',
    user_id: userId,
    tenant_id: tenantApp?.tenantId || ''
  };

  try {
    const anonymousDistinctId = posthog.get_distinct_id();

    posthog.capture('$identify', {
      distinct_id: userId,
      ...(anonymousDistinctId && anonymousDistinctId !== userId
        ? { $anon_distinct_id: anonymousDistinctId }
        : {}),
      $set: userProperties
    });

    posthog.identify(userId);
    console.log('PostHog identify user:', { userId, userProperties });
  } catch (e) {
    console.warn('Error identifying user in PostHog:', e);
  }
};

const beforeSend = event => {
  if (!event) return null;

  const eventProperties = event.properties || {};
  if (eventProperties.$current_url) {
    eventProperties.$current_url = eventProperties.$current_url?.split('?')[0] || '-';
  }

  event.properties = eventProperties;
  return event;
};

const decodeToken = async token => {
  try {
    const host = process.env.REACT_APP_ADMIN_V3_BASE_URL || 'https://staging.bc-solutions.net';
    const decodeTokenUrl = host + '/boost-pfs-admin/admin/decode-token';
    const currentState = store.getState();
    const { authToken } = currentState.oauth;
    const response = await fetch(`${decodeTokenUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-bc-sf-filter-auth': authToken
      },
      body: JSON.stringify({ token })
    });
    const previewData = await response.json();
    return previewData;
  } catch (error) {
    console.error('Warning decoding token:', { error: error.stack });
    return {};
  }
};

export { initPosthog, beforeSend };
